import { type FetchPolicy, graphql, usePaginationFragment } from "react-relay";
import type { postComments_post$key } from "./__generated__/postComments_post.graphql";
import type {
	CommentOrdering,
	postCommentsQuery,
} from "./__generated__/postCommentsQuery.graphql";
import { CommentList } from "./comment-list";

export function PostComments({
	post,
	orderBy,
	setOrderBy,
}: {
	post: postComments_post$key;
	orderBy: CommentOrdering;
	setOrderBy: (orderBy: CommentOrdering) => void;
}) {
	const { data, refetch, loadNext, hasNext } = usePaginationFragment<
		postCommentsQuery,
		postComments_post$key
	>(
		graphql`
    fragment postComments_post on Post
    @refetchable(queryName: "postCommentsQuery")
    @argumentDefinitions(
      	first: { type: "Int", defaultValue: 10 },
      	cursor: { type: "String" }
        orderBy: { type: "CommentOrdering", defaultValue: NEWEST }
		)
    {
      id
      commentCount
      commentPolicy
      comments(first: $first, after: $cursor, orderBy: $orderBy)
      @connection(key: "postComments_post_comments")
      {
        ...commentListFragment
        edges {
          node {
            id
          }
          cursor
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  `,
		post,
	);

	if (data.commentPolicy === "RESTRICTED") {
		return null;
	}

	return (
		<CommentList
			entityId={data.id}
			orderBy={orderBy}
			setOrderBy={(orderBy: CommentOrdering) => setOrderBy(orderBy)}
			loadNext={() => loadNext(3)}
			refetch={(
				opts: { orderBy: CommentOrdering },
				opts2?: { fetchPolicy?: FetchPolicy },
			) => refetch(opts, opts2)}
			hasNext={hasNext}
			comments={data.comments}
			entity="post"
			commentCount={data.commentCount || 0}
		/>
	);
}
